import { Injectable } from '@angular/core';
import { UzurvRestService } from '@uzurv/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagService extends UzurvRestService {
  readonly resourceUrl = 'featureFlags/';

  /**
   * Finds a driver by their ID
   *
   * @param driverId
   * @permission driver
   */
  isCreditCardValidationEnabled(): Observable<boolean> {
    return this.get<boolean>(`${this.resourceUrl}creditCardValidation/`);
  }
}
